// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1T5tTwQznIaRd8yHmp6NvZ","item":"_1zyPuA5iEjYp5-oHwYhN9I","kpiSelected":"_3MV6VmAAZ1LMt2xRsb9wcn","compact":"fzfbzNNrid1BCDLytSXYQ"};